import { Button } from '@/components/ui/button';
import { Maximize2, ClipboardPaste } from 'lucide-react';

const TableSectionHeader = ({ title, onPasteClick, onFullscreenClick, showPasteButton = true, showFullscreenButton = true }) => {
  return (
    <div className="flex items-center gap-2">
      <h2 className="text-base font-bold text-slate-800">{title}</h2>
      <div className="flex gap-0.5">
        {showPasteButton && (
          <Button onClick={onPasteClick} variant="ghost" size="sm" className="h-7 text-[11px] text-slate-500 hover:text-slate-700 gap-1.5 px-2">
            <ClipboardPaste className="w-3.5 h-3.5" /> Paste
          </Button>
        )}
        {showFullscreenButton && (
          <Button onClick={onFullscreenClick} variant="ghost" size="sm" className="h-7 text-[11px] text-slate-500 hover:text-slate-700 gap-1.5 px-2">
            <Maximize2 className="w-3.5 h-3.5" /> Fullskjerm
          </Button>
        )}
      </div>
    </div>
  );
};

export default TableSectionHeader;
